import { Badge, Box, Heading, Text } from "@chakra-ui/react";
import styles from "./ModernPageShell.module.css";

export default function ModernPageShell({
  title,
  subtitle,
  eyebrow = "Sistema Senca",
  centered = false,
  contentMaxW = "760px",
  children,
}) {
  return (
    <Box className={styles.page}>
      <Box className={styles.container}>
        <Box
          className={styles.hero}
          textAlign={centered ? "center" : "left"}
        >
          <Badge
            colorScheme="red"
            variant="subtle"
            borderRadius="full"
            px={3}
            py={1}
            mb={3}
            width="fit-content"
            mx={centered ? "auto" : undefined}
            display="inline-flex"
          >
            {eyebrow}
          </Badge>
          <Heading size="lg" color="gray.800" mb={subtitle ? 2 : 0}>
            {title}
          </Heading>
          {subtitle && (
            <Text
              color="gray.600"
              fontSize="md"
              maxW={centered ? "2xl" : "3xl"}
              mx={centered ? "auto" : undefined}
            >
              {subtitle}
            </Text>
          )}
        </Box>
        {centered ? (
          <Box maxW={contentMaxW} mx="auto" w="full">
            {children}
          </Box>
        ) : (
          children
        )}
      </Box>
    </Box>
  );
}
